import axios from 'axios'

const MemoService = {
  async get (params = {}) {
    return axios.get('mkm/memos', { params })
  },

  async histories (params = {}) {
    return axios.get('mkm/reports/memos', { params })
  },

  async show (id) {
    return axios.get(`mkm/memos/${id}`)
  },

  async post (params = {}) {
    return axios.post('mkm/memos', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`mkm/memos/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`mkm/memos/${data.id}`, { data })
  }
}

export default MemoService
